import { ActionTree } from 'vuex';
import axios from 'axios';
import dialogGroups from '../dialogGroups';

export const actions = {   
    askAva({ dispatch, commit, state, rootState }, ) {
        if (rootState.askAvaQuestion.length > 0) {
            dispatch('sendQuestion', rootState.askAvaQuestion, { root: true });
        } 
    }
};